import React from 'react';
import PropTypes from 'prop-types';

const House = ({ color = '#C70000', width = 7, height = 14 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M2.46901 5.52653C1.6579 6.1574 1 7.50024 1 8.51863V15.1968C1 17.2877 2.70334 19 4.7942 19H15.2305C17.3214 19 19.0247 17.2877 19.0247 15.2058V8.6448C19.0247 7.55431 18.2947 6.1574 17.4025 5.53554L11.8328 1.63319C10.5711 0.749983 8.54334 0.795045 7.32667 1.74134L2.46901 5.52653Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.0124 15.3951V12.6914" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

House.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default House; 